export default "__VITE_ASSET__C6T9b2Ll__"